import * as dateType from '../datepicker-range/action-types';
import { initialState as initialDateState, changeDate } from '../datepicker-range/reducer';

const initialState = initialDateState;

export default (state = initialState, action) => {
  switch (action.type) {
    case dateType.CHANGE_START_DATE:
      return Object.assign({}, state, {
        dateFilter: changeDate(state, action)
      });

    case dateType.CHANGE_END_DATE:
      return Object.assign({}, state, {
        dateFilter: changeDate(state, action)
      });

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/filters/reducer.js
 **/